import React, { useRef, useState, useCallback, useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormPermissoes = ({ isEditing, isLoading, defaultValues }) => {

    const history = useHistory();
    const [isSubmiting, setIsSubmiting] = useState(false);
    const toast = useRef(null);
    const [permissoesList, setPermissoesList] = useState([]);
    const { permissoes } = defaultValues;

    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome do grupo é obrigatório")
            .max(200, "O nome do grupo deve ter no máximo 200 caracteres"),
    })

    const formik = useFormik({
        initialValues: defaultValues,
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: async (data) => {
            setIsSubmiting(true)

            data['permissoes'] = permissoesList.map((p) => {
                delete p.rota_nome
                return p
            });

            try {
                if (!isEditing) {
                    await api.post("grupoPermissoes", data)
                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.nome} adicionado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/permissoes')
                    }, 2000)
                }
                else {

                    await api.put("grupoPermissoes", data)
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.nome} atualizado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/permissoes')
                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar grupo!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar grupo!', detail: error.toString() });
            }

            setIsSubmiting(false)
        }
    })

    const montarBasePermissoes = (rotas) => {
        const pms = [];
        for (let r of rotas) {
            let id = 0;
            let criar = false;
            let editar = false;
            let deletar = false;
            let visualizar = false;
            if (isEditing && permissoes) {
                const permissao = permissoes.find((p) => p.rotaNome === r.nome);
                id = permissao ? permissao.id : 0;
                criar = permissao ? permissao.criar : false;
                deletar = permissao ? permissao.deletar : false;
                editar = permissao ? permissao.editar : false;
                visualizar = permissao ? permissao.visualizar : false;
            }
            pms.push({
                id,
                criar,
                deletar,
                editar,
                visualizar,
                rotaId: r.id,
                rota_nome: r.nome,
            })
        }
        setPermissoesList(pms);
    }

    const getRotas = useCallback(async (size = 100, page = 0) => {
        try {
            const response = await api.get(`rotas?page=${page}&size=${size}`);            
            montarBasePermissoes(response.data.content);
        } catch (error) {
            console.log(error.toString());
        }
    }, []);


    useEffect(() => {
        const fetchRotas = async () => {
            try {
                await getRotas();
            }
            catch (error) {
                console.log(error.toString())
            }
        }
        fetchRotas();

    }, [getRotas]);

    const onCheckRota = (e) => {
        const id = e.target.id.split("_");
        const rota = id[0];
        const acao = id[1];

        const pms = permissoesList.map((p) =>
            p.rota_nome === rota ? { ...p, [acao]: e.target.checked } : p
        );

        setPermissoesList(pms);
    };

    const onCheckRotaAll = (rota) => {
        const pms = permissoesList.map((p) =>
            p.rota_nome === rota
                ? {
                    ...p,
                    criar: !p.criar,
                    editar: !p.editar,
                    deletar: !p.deletar,
                    visualizar: !p.visualizar,
                }
                : p
        );

        setPermissoesList(pms);
    };

    /* const onSubmit = async (e) => {
        e.preventDefault();
        setIsSubmiting(true);
        const pessoa = await api.get(`pessoa/${defaultValues.pessoa_id}`);
        const data = {
            ...pessoa.data,
            permissoes: permissoes.map((p) => {
                delete p.rota_nome
                return p
            }),
        }

        await api.put("pessoa", data)

        toast.current.show({ life: 2000, severity: 'success', summary: 'Permissões atualizadas!', detail: `Permissões atualizadas com sucesso` });
            setTimeout(() => {
                setIsSubmiting(false);
                history.push('/pessoa')
            }, 2000)
    } */

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <h2 className="p-mt-0">Permissões</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                        <div className="p-field p-col-12 p-sm-4">
                            <label
                                htmlFor="nome"
                                className={classNames({ 'p-error': isFormFieldValid('nome') })}
                            >
                                Nome do Grupo
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="nome"
                                        name="nome"
                                        className={classNames({ 'p-invalid': isFormFieldValid('nome') })}
                                        value={formik.values.nome}
                                        onChange={formik.handleChange}

                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.nome && formik.touched.nome &&
                                <ErrorValidationMessage message={formik.errors.nome} />
                            }
                        </div>
                    </div>
                    <div>
                        {!isLoading && permissoesList?.length ?
                            permissoesList.map((p) => {
                                return (
                                    <div key={p["rota_nome"]}>
                                        <p>{p["rota_nome"]}:</p>
                                        <Button
                                            type="button"
                                            className="btn btn-form xcrud-action"
                                            onClick={() =>
                                                onCheckRotaAll(p["rota_nome"])
                                            }
                                        >
                                            Selecionar Todas
                                        </Button>
                                        <input
                                            type="checkbox"
                                            id={p["rota_nome"] + "_criar"}
                                            onChange={onCheckRota}
                                            checked={p["criar"] | false}
                                        />
                                        <label htmlFor={p["rota_nome"] + "_criar"}>
                                            Criar
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={p["rota_nome"] + "_editar"}
                                            onChange={onCheckRota}
                                            checked={p["editar"] | false}
                                        />
                                        <label htmlFor={p["rota_nome"] + "_editar"}>
                                            Editar
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={p["rota_nome"] + "_deletar"}
                                            onChange={onCheckRota}
                                            checked={p["deletar"] | false}
                                        />
                                        <label
                                            htmlFor={p["rota_nome"] + "_deletar"}
                                        >
                                            Deletar
                                        </label>
                                        <input
                                            type="checkbox"
                                            id={p["rota_nome"] + "_visualizar"}
                                            onChange={onCheckRota}
                                            checked={p["visualizar"] | false}
                                        />
                                        <label
                                            htmlFor={p["rota_nome"] + "_visualizar"}
                                        >
                                            Visualizar
                                        </label>
                                    </div>
                                );
                            })
                            :
                            <Skeleton height="35px" />
                        }
                    </div>
                    <div className="p-d-flex p-jc-end p-mr-1">
                        {
                            !isLoading ?
                                <Button
                                    label={isEditing ? 'Atualizar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                />
                                :
                                <Skeleton width="82.16px" height="35px" />

                        }
                    </div>
                </form>
            </div>
        </div>

    );
}
